import $ from 'jquery'
import _ from 'underscore'
import HandlebarsHelper from 'assets/js/handlebarsHelper.js'
import dateValidation from 'assets/js/entry.js'
import gradYear from 'assets/js/gradYear.js'
import entryFormTemplate from './templates/entry.hbs'
import entryConfirmTemplate from './templates/entryConfirm.hbs'

export default postFormData => {
  HandlebarsHelper()
  let prefecture = [ '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県' ]
  let entryTemplate = entryFormTemplate({
    prefecture: prefecture
  })
  $('#entry').append(entryTemplate)

  $(document).on('click', '#resetButton', function () {
    $('#entry').find('input, textarea, :text, radio, select').val('').end().find(':checked').prop('checked', false)
    $('.-error').removeClass('-error')
    $('.p-entry__main-alert').remove()
    $(this).removeClass('hover')
    scrollToForm()
  })
  $(document).on('click', '#backButton', function () {
    $('#entry__confirm-wrap').hide()
    $('#entry-wrap').show()
    $('.-error').removeClass('-error')
    $('.p-entry__main-alert').remove()
    $('#entry .p-entry.confirm').remove()
    window.scrollTo(0, 0)
  })
  $(document).on('click', '#agree', function () {
    return $(this).prop('checked') ? $('#postButton').prop('disabled', false) : $('#postButton').prop('disabled', true)
  })

  $(document).on('click', '#confirmButton', function () {
    let formData = $('form').serializeArray()
    formData.push({ name: 'validate', value: 1 })
    formData = validateMedia(formData)
    formData = validateVisit(formData)
    let jsonData = parseJson(formData)
    entryPost(formData, jsonData)
  })

  $(document).on('click', '#postButton', function () {
    let formData = $('form').serializeArray()
    formData = validateMedia(formData)
    formData = validateVisit(formData)
    let jsonData = parseJson(formData)
    entryPost(formData, jsonData)
  })

  let entryPost = (formData, jsonData) => {
    $.ajax({
      type: 'post',
      url: '/recruit/api/api.cgi',
      data: formData,
      dataType: 'json',
      contentType: 'application/x-www-form-urlencoded',
      beforeSend: function () {
        $('#confirmButton, #postButton').attr('disabled', 'true')
      }
    }).done(function (response) {
      let isConfirm = true
      _.each(formData, (value, key) => {
        return value.name === 'validate' ? (isConfirm = true) : (isConfirm = false)
      })
      if (isConfirm) {
        if (response.result === 'failed') {
          let errorData = response.validation_errors
          let entryTemplate = entryFormTemplate({
            error: errorData,
            data: jsonData,
            prefecture: prefecture
          })
          $('#entry').empty().append(entryTemplate)
          gradYear()
          clearSelect(jsonData)
          dateValidation()
          scrollToAlert()
        } else {
          let confirmTemplate = entryConfirmTemplate({
            jsonData: jsonData,
            formData: formData
          })
          $('#entry-wrap').hide()
          $('#entry__confirm-wrap').show()
          $('#confirm').empty().append(confirmTemplate)
          window.scrollTo(0, 0)
        }
      } else {
        if (response.result === 'failed') {
          let errorData = response.validation_errors
          let entryTemplate = entryFormTemplate({
            error: errorData,
            data: jsonData,
            prefecture: prefecture
          })
          $('#entry__confirm-wrap').hide()
          $('#entry-wrap').show()
          $('#entry').empty().append(entryTemplate)
          gradYear()
          dateValidation()
          clearSelect(jsonData)
          scrollToAlert()
        } else {
          $('#entry-wrap, #entry__confirm-wrap').hide()
          $('#entry__complete-wrap').show()
          window.scrollTo(0, 0)
        }
      }
      $('#confirmButton').removeAttr('disabled', 'false')
    }).fail(function (response) {
      console.log('error')
      console.log(response)
    })
  }

  let clearSelect = (jsonData) => {
    $('#entry').find('select').val('').end()
    Object.keys(jsonData).forEach((item) => {
      $(`#entryForm [name=${item}]`).each(function () {
        if ($(this).prop('tagName') === 'SELECT') {
          $(this).val(jsonData[item])
        }
      })
    })
  }

  let scrollToAlert = () => {
    let target = $('.p-entry__main-alert').offset()
    window.scrollTo(0, target.top)
  }
  let scrollToForm = () => {
    let target = $('.p-entry__form').offset()
    $('html, body').animate({scrollTop: target.top}, 300, 'swing')
  }

  let parseJson = function (data) {
    var returnJson = {}
    for (let i = 0; i < data.length; i++) {
      returnJson[data[i].name] = data[i].value
    }
    return returnJson
  }

  let validateMedia = function (data) {
    data.some(function (v, i) {
      if (v.name === 'media' && v.value !== '雑誌' && v.value !== 'その他') {
        data = data.filter(function (element, index, array) {
          return (element.name !== 'media_magazine' && element.name !== 'media_other')
        })
      } else if (v.name === 'media' && v.value !== '雑誌') {
        data = data.filter(function (element, index, array) {
          return (element.name !== 'media_magazine')
        })
      } else if (v.name === 'media' && v.value !== 'その他') {
        data = data.filter(function (element, index, array) {
          return (element.name !== 'media_other')
        })
      } else {
        return false
      }
    })
    return data
  }
  let validateVisit = function (data) {
    data.some(function (v, i) {
      if (v.name === 'visit' && v.value === '採用選考に応募') {
        data = data.filter(function (element, index, array) {
          return (!element.name.match(/^visit_/))
        })
      } else {
        return false
      }
    })
    return data
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/postEntryForm.js